import { Icon } from '@chakra-ui/react';

export default function ClockArrow2CirclesIcon(props) {
  return (
    <Icon
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M12 4.39062C14.6328 4.39062 16.9609 5.73438 18.4453 7.72656C18.7109 8.07031 18.625 8.5 18.3046 8.6875C17.9843 8.89062 17.6093 8.78906 17.375 8.46875C16.1796 6.80469 14.2265 5.73438 12 5.72656C8.82808 5.72656 6.20308 7.89844 5.53121 10.8516H6.65621C7.21089 10.8516 7.35152 11.2344 7.05464 11.6641L5.30464 14.1562C5.05464 14.5078 4.67964 14.5156 4.42183 14.1562L2.67183 11.6719C2.36714 11.2344 2.50777 10.8516 3.07027 10.8516H4.17964C4.89058 7.19531 8.15621 4.39062 12 4.39062ZM11.7031 7.78125C12.0468 7.78125 12.3203 8.05469 12.3203 8.39844V12.5469L14.2109 15.0938C14.4453 15.4141 14.4218 15.7812 14.1328 15.9844C13.8125 16.2031 13.4531 16.1484 13.1953 15.8125L11.2656 13.2656C11.1328 13.0938 11.0781 12.9375 11.0781 12.7578V8.39844C11.0781 8.05469 11.3593 7.78125 11.7031 7.78125ZM12 20.3281C9.36714 20.3281 7.03902 18.9844 5.55464 16.9922C5.28902 16.6484 5.37496 16.2188 5.68746 16.0234C6.01558 15.8281 6.38277 15.9297 6.62496 16.25C7.82027 17.9141 9.77339 18.9922 12 19C15.164 19 17.7968 16.8125 18.4765 13.8672H17.3437C16.789 13.8672 16.6406 13.4844 16.9453 13.0547L18.6953 10.5625C18.9453 10.2109 19.3203 10.2031 19.5781 10.5625L21.3203 13.0469C21.6328 13.4844 21.4843 13.8672 20.9218 13.8672H19.8203C19.1093 17.5156 15.8437 20.3281 12 20.3281Z'
        fill='currentColor'
      />
    </Icon>
  );
}
